import type { FaireProductEntity } from "../../entity_types/product";

export const p_mna0e5vjkz: FaireProductEntity = {
  token: "p_mna0e5vjkz",
  type: "product",
  name: "IMMUNITY SPRAY | 2 oz",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/6ac40fb54c0288f292d16e577fb94f6b0a1407cc032b82840bdcf14d03904c9a.png",
  galleryImageUrls: [],
  priceDollars: 9.8,
  description:
    "Concerned about all of the air-borne germs in your house, office, or car? Shared spaces lead to shared germs. Now you can get rid of those germs with our safe and effective essential oil blend Immunity Spray. In this convenient 2oz size, you can now take this germ fighting spray with you wherever you go! In your car, purse, backpack, diaper bag...the options are endless!\n\nTO USE: Shake well. Spray on shopping cart, public seating & dining surfaces or anywhere germs may be present.\n\nINGREDIENTS: DISTILLED WATER, COLLOIDAL SILVER & 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: CLOVE, LEMON, CINNAMON BARK, EUCALYPTUS, ROSEMARY, ORANGE",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:10.856Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
